var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "fieldset",
    {
      staticClass: "selectable-tab",
      class: {
        "selectable-tab--active": _vm.active,
        "selectable-tab--small": _vm.small,
        "selectable-tab--disabled": _vm.disabled,
      },
    },
    [
      _c(
        "legend",
        {
          staticClass: "text-caption text-no-wrap ml-n2",
          class: {
            "px-1": _vm.label,
            "text-secondary--text": !_vm.active,
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.label || "​") + "\n  ")]
      ),
      _vm._v(" "),
      _vm._t("prepend"),
      _vm._v(" "),
      _c("div", { staticClass: "text-subtitle-1 text-no-wrap" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-caption text-no-wrap" },
        [
          _vm._t("subtitle", function () {
            return [_vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")]
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }